import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/mapTo';
import * as ResourceApi from 'api/resources';
import {getResourceAction, saveResourceFieldAction, Types as ResourceActions} from 'resources/actions';
import {endAddStepsAction, endDeleteStepsAction, endStepNumbersSaveAction, Types} from './actions';
import {requestBreakAction} from 'pages/EditBreak/actions';

const saveStepNumbersEpic = action$ => action$.ofType(Types.START_STEP_NUMBERS_SAVE)
    .mergeMap(action => {
      const { breakResourceId } = action;

      const stepSaves = action.stepNumbersAndResourceIds.map(({ resourceId, stepNumber }) => {
        const { type, id } = resourceId;
        return ResourceApi.saveField(type, id, 'stepNumber', stepNumber, [resourceId, breakResourceId]);
      });

      // this is a "project function" that happens to return an observable. it's passed as
      // an optional final arg to forkJoin and called when all the observables passed to
      // forkJoin complete; effectively it is the Promise.all of RxJS. in this case, we
      // are fetching the modified break after all step-save observables have completed.
      const breakReload = () => getResourceAction(breakResourceId.type, breakResourceId.id);

      return Observable.forkJoin(...stepSaves, breakReload);
    });

const savedStepNumbersEpic = (action$, store) => action$.ofType(ResourceActions.RECEIVED_RESOURCE)
    .filter(action => {
      const { lastAction } = store.getState().viewAllPlatforms;
      return lastAction === Types.START_STEP_NUMBERS_SAVE;
    })
    .mapTo(endStepNumbersSaveAction());

const togglePublishStepEpic = action$ => action$.ofType(Types.TOGGLE_PUBLISH_STEP)
    .map(action => {
      const { stepResourceId, publishStep, breakResourceId, stepIndex} = action;
      const { type, id } = stepResourceId;

      return saveResourceFieldAction(
        stepResourceId,
        breakResourceId,
        [`steps.${stepIndex}`],
        [`steps.${stepIndex}`, 'publishStep'],
        'publishStep',
        publishStep,
        [stepResourceId, breakResourceId]
      );
    });

const addedStepsEpic = (action$, store) => action$.ofType(ResourceActions.CREATED_RESOURCE)
    .filter(action => {
      const { lastAction } = store.getState().viewAllPlatforms;
      return lastAction === Types.START_ADD_STEPS;
    })
    .mapTo(endAddStepsAction());

const challengeReloadEpic = (action$, store) => action$.ofType(Types.END_ADD_STEPS)
    .mergeMap(action => {
      const {selectedChallengeId} = store.getState().editBreak;
      return Observable.of(requestBreakAction(selectedChallengeId));
    });

const deletedStepsEpic = (action$, store) => action$.ofType(ResourceActions.DELETED_RESOURCE)
    .filter(action => {
      const { lastAction } = store.getState().viewAllPlatforms;
      return lastAction === Types.START_DELETE_STEPS;
    })
    .mapTo(endDeleteStepsAction());

export default [
  saveStepNumbersEpic,
  savedStepNumbersEpic,
  togglePublishStepEpic,
  addedStepsEpic,
  challengeReloadEpic,
  deletedStepsEpic
];



// WEBPACK FOOTER //
// ./public/pages/ViewAllPlatforms/epics.js